import { Component, Output, EventEmitter } from "@angular/core"
import { ModalComponent } from "src/modules/modal/modal.component"

@Component({
  selector: 'new-multipass-subscription-video',
  template: `
    <modal [width]="width" (outsideClick)="close.emit()" [removeVisible]="false">
      <h4 class="text-no-transform text-gray mt-3">+VIDEO</h4>
      <hr class="brand-hr w-25">
      <p class="font-size-18 font-weight-light">
        Let Verblio transform your written content into a short video you can embed as a summary or teaser and amplify on social media.
      </p>
      <p class="text-no-transform font-size-18 text-gray bold mt-4 mb-1">Sample Video</p>
      <embed-video></embed-video>
      <div class="mt-3">
        <button class="btn btn-secondary mt-3" (click)="close.emit()">Close</button>
        <a class="btn btn-outline-secondary mt-3 ml-2" href="https://help.verblio.com/en/articles/6242112-what-is-verblio-video" target="_blank" (click)="close.emit()">More info</a>
      </div>
    </modal>
  `
})
export class NewMultipassSubscriptionVideo extends ModalComponent {
  @Output() close: EventEmitter<null> = new EventEmitter<null>()
}
